import api from "./api";
import routes from "./routes";
import webConfig from "@/config/webConfig";
import ImageConfig from "@/config/ImageConfig";

const config = {
    routes,
    api,
    webConfig,
    ImageConfig,
};

export default config;
